import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  _: Boundaries["retrieveDocumentTemplatesFolder"]["request"],
): State {
  return {
    ...state,
    request: setRequestStateToPending(),
  };
}

function handleSuccess(
  state: State,
  { folder }: Boundaries["retrieveDocumentTemplatesFolder"]["success"],
): State {
  return {
    ...state,
    request: setRequestStateToSuccess(),
    folder,
  };
}

function handleFailure(
  state: State,
  _: Boundaries["retrieveDocumentTemplatesFolder"]["failure"],
): State {
  return {
    ...state,
    request: setRequestStateToFailure(),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveDocumentTemplatesFolderRequested]: handleRequest,
    [events.retrieveDocumentTemplatesFolderSucceeded]: handleSuccess,
    [events.retrieveDocumentTemplatesFolderFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
